import type { CUJobStore } from "@/store/useCUCompositeJobStore";

let cachedSections: CUJobStore["sections"] | null = null;
let cachedDataForSubmit: Record<string, unknown> = {};

const getDataForSubmit = (sections: CUJobStore["sections"]) => {
  if (sections === cachedSections) {
    return cachedDataForSubmit;
  }
  cachedSections = sections;
  cachedDataForSubmit = Object.values(sections).reduce((acc: any, section: any) => {
    if (!section?.data) return acc;
    return {
      ...acc,
      ...section.data,
    };
  }, {});
  return cachedDataForSubmit;
};

export const selectStateForJob = (state: CUJobStore) => {
  const sections = state.sections;
  const slotPinholeCheck =
    !sections.slotPinholeDetails ||
    sections.slotPinholeDetails.status === "hidden" ||
    sections.slotPinholeDetails.isDataFilled;
  const buriedCheck =
    !sections.buriedDetails || sections.buriedDetails.status === "hidden" || sections.buriedDetails.isDataFilled;
  const extraLayersCheck =
    !sections.extraLayers || sections.extraLayers.status === "hidden" || sections.extraLayers.isDataFilled;
  const diameterEncompassingCheck =
    !sections.diameterEncompassingEntireThinDefectSection ||
    sections.diameterEncompassingEntireThinDefectSection.status === "hidden" ||
    sections.diameterEncompassingEntireThinDefectSection.isDataFilled;
  const utReadingCheck =
    !sections.utReadingSection ||
    sections.utReadingSection.status === "hidden" ||
    sections.utReadingSection.isDataFilled;
  const pressureCyclesCheck =
    !sections.pressureCyclesSection ||
    sections.pressureCyclesSection.status === "hidden" ||
    sections.pressureCyclesSection.isDataFilled;
  const additionalForcesAndMomentsCheck =
    !sections.additionalForcesAndMomentsSection ||
    sections.additionalForcesAndMomentsSection.status === "hidden" ||
    sections.additionalForcesAndMomentsSection.isDataFilled;
  const externalPressureVacuumCheck =
    !sections.externalPressureVacuumSection ||
    sections.externalPressureVacuumSection.status === "hidden" ||
    sections.externalPressureVacuumSection.isDataFilled;

  const areAllRequiredFieldsFilled =
    sections.jobDetails.isDataFilled &&
    sections.additionalJobDetails.isDataFilled &&
    sections.contactInformation.isDataFilled &&
    sections.designConditions.isDataFilled &&
    sections.operatingConditions.isDataFilled &&
    sections.componentDetails.isDataFilled &&
    sections.checksSection.isDataFilled &&
    slotPinholeCheck &&
    buriedCheck &&
    extraLayersCheck &&
    diameterEncompassingCheck &&
    utReadingCheck &&
    pressureCyclesCheck &&
    additionalForcesAndMomentsCheck &&
    externalPressureVacuumCheck &&
    sections.defectDetails.isDataFilled;

  const dataForSubmit = getDataForSubmit(state.sections);
  const atLeastOneSectionFilled =
    sections.jobDetails.isDataFilled ||
    sections.additionalJobDetails.isDataFilled ||
    sections.contactInformation.isDataFilled ||
    sections.designConditions.isDataFilled ||
    sections.operatingConditions.isDataFilled ||
    sections.componentDetails.isDataFilled ||
    sections.checksSection.isDataFilled ||
    (sections.slotPinholeDetails && slotPinholeCheck) ||
    (sections.buriedDetails && buriedCheck) ||
    (sections.extraLayers && extraLayersCheck) ||
    (sections.diameterEncompassingEntireThinDefectSection && diameterEncompassingCheck) ||
    (sections.utReadingSection && utReadingCheck) ||
    (sections.pressureCyclesSection && pressureCyclesCheck) ||
    (sections.additionalForcesAndMomentsSection && additionalForcesAndMomentsCheck) ||
    (sections.externalPressureVacuumSection && externalPressureVacuumCheck) ||
    sections.defectDetails.isDataFilled;

  return {
    areAllRequiredFieldsFilled,
    atLeastOneSectionFilled,
    dataForSubmit,
    ...state,
  };
};
